export default __webpack_public_path__ + "static/media/MoneyB.e150e803.svg";